import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { AnnotationListItem } from '../AnnotationListItem';
import { useStyles } from './useStyles';

export const AnnotationListValue = ({
  className,
  entries,
  interactive,
  onUseClick,
  hint,
  toolMaxWordsPerKeyword,
}) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      {entries.map((item) => (
        <AnnotationListItem
          className={styles.item}
          key={item?.name || item}
          annotation={item}
          onUseClick={onUseClick}
          hint={hint}
          interactive={interactive}
          toolMaxWordsPerKeyword={toolMaxWordsPerKeyword}
        />
      ))}
    </div>
  );
};

AnnotationListValue.propTypes = {
  className: PropTypes.string,
  entries: PropTypes.arrayOf(PropTypes.oneOf([PropTypes.string, PropTypes.shape()])).isRequired,
  interactive: PropTypes.bool,
  onUseClick: PropTypes.func.isRequired,
  hint: PropTypes.string,
  toolMaxWordsPerKeyword: PropTypes.number.isRequired,
};

AnnotationListValue.defaultProps = {
  className: null,
  interactive: false,
  hint: null,
};
